import { IComponent } from "./iComponent";

export interface IPopupComponent<T> extends IComponent<T> {
  isPopup?(): boolean;

  /** Called when focus is within the component */
  focusIn?(): void;

  /** Called when focus is leaving the component */
  focusOut?(): void;
}